export default __webpack_public_path__ + "static/media/ies_nuestrosPatrocinadores_ENG.541c0264.png";